import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Papa from 'papaparse';
import { useHistory } from 'react-router-dom';

const TesoComprobantesGrilla = () => {
  const [extbcoModalOpen, setExtbcoModalOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(Array(5).fill(null));
  const [saldo, setSaldo] = useState(Array(5).fill(0));
  const [observaciones, setObservaciones] = useState('');
  const [totalSaldo, setTotalSaldo] = useState(0);
  const [fechaCbte, setFechaCbte] = useState('');
  const [fechaExtracto, setFechaExtracto] = useState('');
  const [items, setItems] = useState([]);
  const [estadoItems, setEstadoItems] = useState({});
  const [saldosItems, setSaldosItems] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemModalOpen, setItemModalOpen] = useState(false);
  const [conceptos, setCuentas] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [lopsModalOpen, setLopsModalOpen] = useState(false);
  const [lopsSaldo, setLopsSaldo] = useState(0);
  const [itemRegistros, setItemRegistros] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [sortKey, setSortKey] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const history = useHistory();

  const showToast = (title, description = '', severity = 'info') => {
    setSnackbar({ open: true, message: description ? `${title}: ${description}` : title, severity });
  };

  useEffect(() => {
    fetchItems();
  }, []); // Ejecuta esto solo una vez al montar el componente.

  useEffect(() => {
    const fetchEstadoYSaldo = async () => {
      const promises = items.map(async (item) => {
        const id = item.id_comprobante_item;

        try {
          // Fetch estado
          const estadoURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/items/${id}/estado-conciliacion`;
          const estadoResponse = await fetch(estadoURL, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "Authorization": localStorage.getItem("token"),
            },
          });

          const estadoData = estadoResponse.ok ? await estadoResponse.json() : { estado: "Error" };

          // Fetch saldo
          const saldoURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/items/${id}/saldo`;
          const saldoResponse = await fetch(saldoURL, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "Authorization": localStorage.getItem("token"),
            },
          });

          const saldoData = saldoResponse.ok ? await saldoResponse.json() : { saldo: "Error" };


          return { id, estado: estadoData.estado, saldo: saldoData.saldo };
        } catch (error) {
          console.error(`Error fetching data for item ${id}:`, error);
          return { id, estado: "Error", saldo: "Error" };
        }
      });

      // Espera a que todas las promesas terminen y actualiza el estado
      const results = await Promise.all(promises);
      const nuevosEstados = {};
      const nuevosSaldos = {};

      results.forEach(({ id, estado, saldo }) => {
        nuevosEstados[id] = estado;
        nuevosSaldos[id] = saldo;
      });

      setEstadoItems((prev) => ({ ...prev, ...nuevosEstados }));
      setSaldosItems((prev) => ({ ...prev, ...nuevosSaldos }));
    };

    if (items.length > 0) {
      fetchEstadoYSaldo();
    }
  }, [items]); // ESTADO Y SALDO ITEMS - Ejecuta esto cuando cambien los items

  useEffect(() => {
    async function fetchConceptos() {
      try {

        const baseURL = `${process.env.REACT_APP_API_URL}/conceptos/extbco`;
        const response = await fetch(baseURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": localStorage.getItem("token"),
          },
        });

        if (response.ok) {
          const result = await response.json();
          setCuentas(result);
        } else {
          console.error("Error fetching conceptos:", response.statusText);
        }

      } catch (error) {
        console.error('Error fetching conceptos:', error);
      }
    }
    fetchConceptos();
  }, []); // CONCEPTOS

  const handleFileUpload = (index, file, isLops = false) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const csvData = event.target.result;

      Papa.parse(csvData, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          let data = result.data;

          // Invertir el array para que el saldo se calcule desde el registro más antiguo al más reciente
          data = data.slice().reverse();

          // Función para limpiar y convertir valores monetarios
          const parseMonetaryValue = (value) => {
            // Verificar si el valor solo contiene números y/o un punto
            if (/^\d+(\.\d+)?$/.test(value)) {
              return parseFloat(value);
            }

            if (typeof value !== "string") {
              throw new Error("La entrada debe ser string");
            }

            // Eliminar el símbolo de dólar y los paréntesis (si los hay)
            let sanitizedInput = value.replace(/[\$\(\)]/g, '');

            // Si el valor ya es numérico, devolverlo tal cual
            if (typeof value === "number") {
              return value;
            }

            let numericValue;

            if (typeof value === "string") {
              // Eliminar el símbolo de dólar y los paréntesis (si los hay)
              let sanitizedInput = value.replace(/[\$\(\)]/g, '');

              // Identificar si el valor es negativo (puede ser con paréntesis o guion)
              const isNegative = value.includes('(') || value.includes('-');

              // Eliminar puntos como separadores de miles y cambiar comas por puntos
              sanitizedInput = sanitizedInput
                .replace(/\./g, '') // Eliminar puntos
                .replace(/,/g, '.'); // Cambiar comas por puntos

              // Parsear el número
              numericValue = parseFloat(sanitizedInput);

              if (isNaN(numericValue)) {
                throw new Error("Formato inválido para valor monetario.");
              }

              // Si es negativo, cambiar el signo
              if (isNegative) {
                numericValue = -Math.abs(numericValue);
              }
            } else {
              throw new Error("Tipo de valor no soportado.");
            }

            return numericValue;
          };

          if (isLops) {
            let saldoAcumulado = 0;
            data.forEach(row => {
              const importe = parseMonetaryValue(row['Importe']);
              saldoAcumulado += importe;
            });
            setLopsSaldo(saldoAcumulado);
            const newFiles = [...selectedFiles];
            newFiles[0] = { file, id_concepto: null };
            setSelectedFiles(newFiles);
          } else {
            // Extraer el último saldo (ahora es el saldo de la última fila después de invertir)
            const lastRow = data[data.length - 1];
            let lastSaldo = lastRow?.Saldo;
            if (typeof lastRow?.Saldo === "string") {
              lastSaldo = parseMonetaryValue(lastRow?.Saldo);
            }

            const newSaldo = [...saldo];
            newSaldo[index] = lastSaldo || 0;
            setSaldo(newSaldo);
            setTotalSaldo(newSaldo.reduce((acc, curr) => acc + curr, 0));

            const newFiles = [...selectedFiles];
            newFiles[index] = { file, id_concepto: conceptos[index]?.id_concepto };
            setSelectedFiles(newFiles);
          }
        },
        error: (error) => {
          console.error("Error al procesar el archivo CSV:", error);
          showToast("Error al procesar archivo", "No se pudo leer el archivo. Verifica su formato.", "error");
        },
      });
    };

    reader.readAsText(file);
  };

  // Funcion para guardar un comprobante EXTBCO
  const handleSaveExtbco = async () => {
    setIsLoading(true); // Inicia el estado de carga
    const formData = new FormData();
    selectedFiles.forEach((entry) => {
      if (entry && entry.file) {
        formData.append('archivos', entry.file);
        formData.append('ids_concepto', entry.id_concepto);
      }
    });
    formData.append('fecha_emision', fechaCbte);
    formData.append('fecha_archivos', fechaExtracto);
    formData.append('id_empresa', 1);
    formData.append('pvt_numero', "00001");
    formData.append('observaciones', observaciones);

    try {

      const baseURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/extbco`;

      const response = await fetch(baseURL, {
        method: "POST",
        headers: {
          "Authorization": localStorage.getItem("token"),
        },
        body: formData,
      });

      if (response.ok) {
        showToast('Guardado con éxito.', 'El EXTBCO fue guardado correctamente.', 'success');
        setExtbcoModalOpen(false);
        fetchItems();
      } else {
        throw new Error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error saving EXTBCO:", error);
      showToast("Error al guardar.", "No se pudo guardar el EXTBCO.", "error");
    } finally {
      setIsLoading(false); // Finaliza el estado de carga
    }
  };

  // Funcion para guardar un comprobante LOPS
  const handleSaveLops = async () => {
    setIsLoading(true); // Inicia el estado de carga
    const formData = new FormData();
    if (selectedFiles[0] && selectedFiles[0].file) {
      formData.append('file', selectedFiles[0].file);
    }
    formData.append('fecha_emision', fechaCbte);
    formData.append('fecha_archivos', fechaExtracto);
    formData.append('observaciones', observaciones);

    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/lops`;

      const response = await fetch(baseURL, {
        method: "POST",
        headers: {
          "Authorization": localStorage.getItem("token"),
        },
        body: formData,
      });

      if (response.ok) {
        showToast('Guardado con éxito.', 'El LOPS fue guardado correctamente.', 'success');
        setLopsModalOpen(false);
        fetchItems();
      } else {
        throw new Error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error saving LOPS:", error);
      showToast("Error al guardar.", "No se pudo guardar el LOPS.", "error");
    } finally {
      setIsLoading(false); // Finaliza el estado de carga
    }
  };

  // Función para obtener los items
  const fetchItems = async (page = 1) => {
    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/items?page=${page}`;
      const response = await fetch(baseURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": localStorage.getItem("token"),
        },
      });

      if (response.ok) {
        const result = await response.json();
        setItems(result.items);
        setTotalPages(result.totalPages);
        setCurrentPage(result.currentPage);
      } else {
        console.error("Error fetching items:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  // Funcion para eliminar un item
  const handleDelete = async (id) => {
    const baseURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/items/${id}`;
    try {
      const response = await fetch(baseURL, {
        method: "DELETE",
        headers: {
          "Authorization": localStorage.getItem("token"),
        },
      });

      if (response.ok) {
        // Filtra el item eliminado del estado
        setItems((prev) =>
          prev.filter((item) => item.id_comprobante_item !== id)
        );
        showToast("Eliminado con éxito.", `El item con ID ${id} fue eliminado.`, "success");
      } else {
        throw new Error(`Error: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      showToast("Error al eliminar.", `No se pudo eliminar el item con ID ${id}.`, "error");
    }
  };

  // Funcion para abrir modal de eliminación
  const confirmDelete = (id) => {
    setItemToDelete(id);
    setDeleteModalOpen(true);
  };

  // Funcion para ver un item
  const handleViewItem = async (item) => {
    setSelectedItem(item);
    setItemModalOpen(true);
    const baseURL = `${process.env.REACT_APP_API_URL}/tesoreriacomprobantes/items/${item.id_comprobante_item}/registros`;
    try {
      const response = await fetch(baseURL, {
        method: "GET",
        headers: {
          "Authorization": localStorage.getItem("token"),
        },
      });

      const data = await response.json();
      setItemRegistros(data);
    } catch (error) {
      console.error('Error fetching registros:', error);
    }
  };

  // Funcion para ordenar items
  const handleSort = (key) => {
    let order = "asc";
    if (sortKey === key && sortOrder === "asc") {
      order = "desc";
    }
    setSortKey(key);
    setSortOrder(order);

    const sortedItems = [...items].sort((a, b) => {
      const valA = key.includes(".") ? key.split(".").reduce((o, k) => o?.[k], a) : a[key];
      const valB = key.includes(".") ? key.split(".").reduce((o, k) => o?.[k], b) : b[key];

      const numA = !isNaN(valA) ? Number(valA) : null;
      const numB = !isNaN(valB) ? Number(valB) : null;

      if (numA !== null && numB !== null) {
        // Comparar como números
        return order === "asc" ? numA - numB : numB - numA;
      } else if (typeof valA === "string" && typeof valB === "string") {
        // Comparar como cadenas
        return order === "asc" ? valA.localeCompare(valB) : valB.localeCompare(valA);
      }
      return 0; // Si los valores no son comparables, los dejamos como están
    });
    setItems(sortedItems);
  };

  const resetExtbcoModal = () => {
    setSelectedFiles(Array(5).fill(null));
    setSaldo(Array(5).fill(0));
    setObservaciones('');
    setTotalSaldo(0);
    setFechaCbte('');
    setFechaExtracto('');
  };

  const resetLopsModal = () => {
    setSelectedFiles(Array(5).fill(null));
    setLopsSaldo(0);
    setObservaciones('');
    setFechaCbte('');
    setFechaExtracto('');
  };

  const openExtbcoModal = () => {
    resetExtbcoModal();
    setExtbcoModalOpen(true);
  };

  const openLopsModal = () => {
    resetLopsModal();
    setLopsModalOpen(true);
  };

  return (
    <Box sx={{ p: 2, pt: '120px' }}>

      {/* Botones para modal */}
      <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
        <Button variant="contained" size="small" onClick={openExtbcoModal}>
          Nuevo EXTBCO
        </Button>
        <Button variant="contained" size="small" onClick={openLopsModal}>
          Nuevo LOPS
        </Button>
        <Button variant="outlined" size="small" onClick={() => history.push('/admin/conciliarops')}>
          Conciliar OPS
        </Button>
      </Box>

      {/* Grid para items */}
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell component="th" sx={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={() => handleSort("id_comprobante_item")}>
                ID Item {sortKey === "id_comprobante_item" && (sortOrder === "asc" ? "↑" : "↓")}
              </TableCell>
              <TableCell component="th" sx={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={() => handleSort("fecha_archivos")}>
                Fecha Extracto {sortKey === "fecha_archivos" && (sortOrder === "asc" ? "↑" : "↓")}
              </TableCell>
              <TableCell component="th" sx={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={() => handleSort("id_empresa")}>
                Cta Bco {sortKey === "id_empresa" && (sortOrder === "asc" ? "↑" : "↓")}
              </TableCell>
              <TableCell component="th" sx={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={() => handleSort("fecha_emision")}>
                Fecha Cbte {sortKey === "fecha_emision" && (sortOrder === "asc" ? "↑" : "↓")}
              </TableCell>
              <TableCell component="th" sx={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={() => handleSort("id_comprobante")}>
                Cbte {sortKey === "id_comprobante" && (sortOrder === "asc" ? "↑" : "↓")}
              </TableCell>
              <TableCell component="th" sx={{ cursor: 'pointer', fontWeight: 'bold' }} onClick={() => handleSort("total")}>
                Saldo {sortKey === "total" && (sortOrder === "asc" ? "↑" : "↓")}
              </TableCell>
              <TableCell component="th" sx={{ fontWeight: 'bold' }}>Estado</TableCell>
              <TableCell component="th" sx={{ fontWeight: 'bold' }}>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, index) => (
              <TableRow key={index} sx={{ '&:nth-of-type(odd)': { backgroundColor: 'action.hover' } }}>
                <TableCell>{item.id_comprobante_item}</TableCell>
                <TableCell>{item.comprobantes.fecha_archivos}</TableCell>
                <TableCell>{conceptos.find(concepto => concepto.id_concepto === item.id_concepto)?.descripcion || "GLM"}</TableCell>
                <TableCell>{item.comprobantes.fecha_emision}</TableCell>
                <TableCell>{`${item.comprobantes.tco_codigo} N° ${item.id_comprobante}`}</TableCell>
                <TableCell sx={{ textAlign: 'right' }}>
                  {item.comprobantes.total !== undefined && item.comprobantes.total !== null
                    ? Number(item.comprobantes.total).toFixed(2)
                    : "0.00"}
                </TableCell>
                <TableCell>{estadoItems[item.id_comprobante_item] || "Cargando..."}</TableCell>
                <TableCell>
                  <Button variant="contained" color="primary" size="small" sx={{ mr: 1 }} onClick={() => handleViewItem(item)}>
                    Ver
                  </Button>
                  <Button variant="contained" color="error" size="small" onClick={() => confirmDelete(item.id_comprobante_item)}>
                    Eliminar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Paginación */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
        <Button onClick={() => fetchItems(currentPage - 1)} disabled={currentPage === 1}>
          Anterior
        </Button>
        <Box>
          Página {currentPage} de {totalPages}
        </Box>
        <Button onClick={() => fetchItems(currentPage + 1)} disabled={currentPage === totalPages}>
          Siguiente
        </Button>
      </Box>

      {/* CREAR EXTBCO Modal */}
      <Dialog open={extbcoModalOpen} onClose={() => { resetExtbcoModal(); setExtbcoModalOpen(false); }} maxWidth="md" fullWidth>
        <DialogTitle>
          Nuevo EXTBCO
          <IconButton onClick={() => { resetExtbcoModal(); setExtbcoModalOpen(false); }} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <Box>
              <Typography variant="body2" gutterBottom>Fecha Cbte:</Typography>
              <TextField type="date" size="small" fullWidth value={fechaCbte} onChange={(e) => setFechaCbte(e.target.value)} />
            </Box>
            <Box>
              <Typography variant="body2" gutterBottom>Fecha Extracto:</Typography>
              <TextField type="date" size="small" fullWidth value={fechaExtracto} onChange={(e) => setFechaExtracto(e.target.value)} />
            </Box>

            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell>Saldo</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {conceptos.map((concepto, index) => (
                  <TableRow key={concepto.id_concepto}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{concepto.descripcion}</TableCell>
                    <TableCell>
                      <input
                        type="file"
                        accept=".csv"
                        onChange={(e) => handleFileUpload(index, e.target.files[0])}
                      />
                    </TableCell>
                    <TableCell>{saldo[index]?.toFixed(2) || "0.00"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={3}>Total</TableCell>
                  <TableCell>{totalSaldo.toFixed(2)}</TableCell>
                </TableRow>
              </TableFooter>
            </Table>

            <Box>
              <Typography variant="body2" gutterBottom>Observaciones:</Typography>
              <TextField
                multiline
                rows={3}
                size="small"
                fullWidth
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleSaveExtbco}>
            Guardar
          </Button>
          <Button onClick={() => setExtbcoModalOpen(false)}>Cancelar</Button>
        </DialogActions>
      </Dialog>

      {/* CREAR LOPS Modal */}
      <Dialog open={lopsModalOpen} onClose={() => { resetLopsModal(); setLopsModalOpen(false); }} maxWidth="sm" fullWidth>
        <DialogTitle>
          Nuevo LOPS
          <IconButton onClick={() => { resetLopsModal(); setLopsModalOpen(false); }} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <Box>
              <Typography variant="body2" gutterBottom>Fecha Cbte:</Typography>
              <TextField type="date" size="small" fullWidth value={fechaCbte} onChange={(e) => setFechaCbte(e.target.value)} />
            </Box>
            <Box>
              <Typography variant="body2" gutterBottom>Fecha Orden de Pago:</Typography>
              <TextField type="date" size="small" fullWidth value={fechaExtracto} onChange={(e) => setFechaExtracto(e.target.value)} />
            </Box>
            <Box>
              <Typography variant="body2" gutterBottom>Observaciones:</Typography>
              <TextField multiline rows={3} size="small" fullWidth value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
            </Box>
            <Box>
              <Typography variant="body2" gutterBottom>Archivo CSV:</Typography>
              <input type="file" accept=".csv" onChange={(e) => handleFileUpload(0, e.target.files[0], true)} />
            </Box>
            <Box>
              <Typography variant="body2" gutterBottom>Saldo:</Typography>
              <TextField type="text" size="small" fullWidth value={lopsSaldo.toFixed(2)} InputProps={{ readOnly: true }} />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={handleSaveLops}>
            Guardar
          </Button>
          <Button onClick={() => setLopsModalOpen(false)}>Cancelar</Button>
        </DialogActions>
      </Dialog>

      {/* VER ITEM Modal */}
      <Dialog open={itemModalOpen} onClose={() => setItemModalOpen(false)} maxWidth="xl" fullWidth PaperProps={{ sx: { maxHeight: '90vh', height: '90vh' } }}>
        <DialogTitle>
          Información del Ítem
          <IconButton onClick={() => setItemModalOpen(false)} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ overflowY: 'auto' }}>
          {selectedItem && (
            <Box>
              <Typography variant="h6">ID {selectedItem.id_comprobante_item}</Typography>
              <br />
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Paper sx={{ p: 2, bgcolor: 'primary.light', color: 'white', borderRadius: 1 }}>
                    <p><strong>Concepto:</strong> {conceptos.find(concepto => concepto.id_concepto === selectedItem.id_concepto)?.descripcion || "GLM"}</p>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Paper sx={{ p: 2, bgcolor: 'primary.light', color: 'white', borderRadius: 1 }}>
                    <p>
                      <strong>Saldo:</strong> $ {
                        selectedItem.comprobantes && selectedItem.comprobantes.total !== undefined && selectedItem.comprobantes.total !== null
                          ? Number(selectedItem.comprobantes.total).toFixed(2)
                          : "0.00"
                      }
                    </p>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Paper sx={{ p: 2, bgcolor: 'primary.light', color: 'white', borderRadius: 1 }}>
                    <p><strong>Estado:</strong> {estadoItems[selectedItem.id_comprobante_item] || "Cargando..."}</p>
                  </Paper>
                </Grid>
              </Grid>
              <br />
              <Grid container spacing={2} sx={{ border: '1px solid grey', borderRadius: 1 }}>
                <Grid item xs={12} md={4}>
                  <Box sx={{ p: 2 }}>
                    <p><strong>ID Comprobante:</strong> {selectedItem.id_comprobante}</p>
                    <p><strong>TCO Código:</strong> {selectedItem.comprobantes.tco_codigo}</p>
                    <p><strong>Letra Comprobante:</strong> {selectedItem.comprobantes.letra_comprobante}</p>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box sx={{ p: 2 }}>
                    <p><strong>Fecha Comprobante:</strong> {selectedItem.comprobantes.fecha_emision}</p>
                    <p><strong>Fecha Extracto:</strong> {selectedItem.comprobantes.fecha_archivos}</p>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box sx={{ p: 2 }}>
                    <p><strong>ID Usuario:</strong> {selectedItem.comprobantes.id_usuario}</p>
                    <p><strong>Total:</strong> $ {selectedItem.comprobantes.total}</p>
                  </Box>
                </Grid>
              </Grid>
              <br />
              <Box sx={{ p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
                <p><strong>Observaciones:</strong> {selectedItem.comprobantes.observaciones}</p>
              </Box>
              <br />
              <hr />
              <br />
              <Typography variant="subtitle1" fontWeight="bold">Registros</Typography>
              <TableContainer component={Paper} sx={{ mt: 2 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        component="th"
                        sx={{ cursor: 'pointer', fontWeight: 'bold' }}
                        onClick={() => {
                          setItemRegistros((prev) => [...prev].reverse());
                        }}
                      >
                        Orden ↕
                      </TableCell>
                      <TableCell component="th" sx={{ fontWeight: 'bold' }}>Fecha Movimiento</TableCell>
                      <TableCell component="th" sx={{ fontWeight: 'bold' }}>Fecha Valor</TableCell>
                      <TableCell component="th" sx={{ fontWeight: 'bold', flex: 1 }}>Descripción</TableCell>
                      <TableCell component="th" sx={{ fontWeight: 'bold' }}>Num Comprobante</TableCell>
                      <TableCell component="th" sx={{ fontWeight: 'bold', textAlign: 'center', whiteSpace: 'nowrap', minWidth: 100 }}>Débito</TableCell>
                      <TableCell component="th" sx={{ fontWeight: 'bold', textAlign: 'center', whiteSpace: 'nowrap', minWidth: 100 }}>Crédito</TableCell>
                      <TableCell component="th" sx={{ fontWeight: 'bold', textAlign: 'center', whiteSpace: 'nowrap', minWidth: 100 }}>Saldo</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {itemRegistros.map((registro, index) => (
                      <TableRow key={index} sx={{ '&:nth-of-type(odd)': { backgroundColor: 'action.hover' } }}>
                        <TableCell>{registro.num_orden}</TableCell>
                        <TableCell>{new Date(registro.fecha_movimiento).toLocaleDateString('es-ES')}</TableCell>
                        <TableCell>{new Date(registro.fecha_valor).toLocaleDateString('es-ES')}</TableCell>
                        <TableCell sx={{ flex: 1 }}>{registro.descripcion}</TableCell>
                        <TableCell>{registro.num_comprobante}</TableCell>
                        <TableCell sx={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                          $ {typeof registro.debito === "number" ? registro.debito.toFixed(2) : (registro.debito ? Number(registro.debito).toFixed(2) : "0.00")}
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                          $ {typeof registro.credito === "number" ? registro.credito.toFixed(2) : (registro.credito ? Number(registro.credito).toFixed(2) : "0.00")}
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                          $ {typeof registro.saldo === "number" ? registro.saldo.toFixed(2) : (registro.saldo ? Number(registro.saldo).toFixed(2) : "0.00")}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={() => setItemModalOpen(false)}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* ELIMINAR ITEM Modal */}
      <Dialog open={deleteModalOpen} onClose={() => setDeleteModalOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>
          Confirmar Eliminación
          <IconButton onClick={() => setDeleteModalOpen(false)} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          ¿Estás seguro de que deseas eliminar el ítem con ID {itemToDelete}?
          Esta acción no se puede deshacer.
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              handleDelete(itemToDelete);
              setDeleteModalOpen(false);
            }}
          >
            Confirmar
          </Button>
          <Button onClick={() => setDeleteModalOpen(false)}>Cancelar</Button>
        </DialogActions>
      </Dialog>

      {/* CARGANDO Modal */}
      <Dialog open={isLoading} maxWidth="xs">
        <DialogTitle>Espere, cargando...</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress size={60} />
          </Box>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar(s => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar(s => ({ ...s, open: false }))}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TesoComprobantesGrilla;
